<template lang="pug">
#pop_up_preview_wrap
  .text-center.mb-2(v-if="show_play_btn")
    button.btn.btn-default.btn-sm(@click="toggleModalPlay")
      template(v-if="modal_playing")
        i.fa.fa-pause
        | 停止
      template(v-else)
        i.fa.fa-play
        | 再生

  .preview-stack
    .device-panel(v-if="show_pc")
      .device-label
        span
          i.fas.fa-desktop.mr-1
          | PC
        span.text-muted {{ pcSizeLabel }}
      .pc.pc-popup-preview.position-relative.text-center(ref="pcPopup")
        img.mx-auto.pc-imac-bg(ref="pcImacBg", src="/img/imac_bg.jpg", alt="", @load="updatePcScreenMetrics")
        #pop_up_preview_pc.pop-up-preview-root.pc-preview-screen(ref="pcPreviewScreen", :style="pcPreviewScreenStyle")
          .kenga-modal(
            v-if="hasPcPreviewContent",
            :class="{fade_in: is_fade_in, spin_in: is_spin_in, bottom_to_top: is_bottom_to_top, top_to_bottom: is_top_to_bottom, left_to_right: is_left_to_right, right_to_left: is_right_to_left}"
          )
            input.kenga-modal-check(value='1', type='checkbox', id='#token-modal-check-pc', v-model="modal_checked")
            .kenga-modal-body
              .kenga-modal-window(:style="pcModalWindowStyle")
                label.kenga-modal-label(for='#')
                  svg(viewBox='0 0 16 16', width='16', height='16', aria-hidden='true')
                    polygon(
                      fill='#fff',
                      points='14.4,3.1 12.9,1.6 8,6.6 3.1,1.6 1.6,3.1 6.6,8 1.6,12.9 3.1,14.4 8,9.4 12.9,14.4 14.4,12.9 9.4,8'
                    )
                .kenga-modal-inner
                  .countdown_wrap(v-if="countdown", :style="{ backgroundColor: countdown_bg_color}")
                    .countdown_txt(:style="{ color: countdown_font_color}")
                      | {{prefix_countdown_text}}
                      template(v-if="countdown_type == 'specific_date' && daysleft!=0")
                        em {{daysleft}}
                        |日
                      em {{hoursleft}}
                      |時間
                      em {{minutesleft}}
                      |分
                      em {{secondsleft}}
                      |秒
                  .kenga-modal-content
                    img(:src="pcImageSrc", :style="iframe_mode ? 'width:100%;height:auto;display:block;' : ''", :key="'pc-' + pcImageSrc", v-if="pcImageSrc")
                    .texts(v-if="!iframe_mode && title", :class="{no_action: !arrow_btn_flag}")
                      .title
                        a(href='#', target='_blank') {{title}}
                      .action
                        a(href='#', target='_blank')
                          img(src="/img/rectan_action_btn.png")
                    .texts(v-else-if="!iframe_mode && arrow_btn_flag")
                      .title
                        p {{""}}
                      .action
                        a(href='#', target='_blank')
                          img(src="/img/rectan_action_btn.png")
                #kenga_footer(v-if="show_credit")
                  a(href='https://sitelead.net', target='_blank') Powered By SiteLead
          .preview-empty.preview-empty--in-screen(v-else)
            | PC用画像が登録されていません

    .device-panel(v-if="show_sp")
      .device-label
        span
          i.fas.fa-mobile-alt.mr-1
          | スマートフォン
        span.text-muted 自動
      .iphone-fit-wrap(ref="spFitWrap", :style="spWrapStyle")
        .iphone-scale-inner(:style="spScaleInnerStyle")
          .iphone
            .iphone-top
              span.camera
              span.sensor
              span.speaker
            .top-bar
            .iphone-screen
              #pop_up_preview_sp.pop-up-preview-root(v-if="hasSpPreviewContent")
                .kenga-modal(:class="{fade_in: is_fade_in, spin_in: is_spin_in, bottom_to_top: is_bottom_to_top, top_to_bottom: is_top_to_bottom, left_to_right: is_left_to_right, right_to_left: is_right_to_left}")
                  input.kenga-modal-check(value='1', type='checkbox', id='#token-modal-check-sp', v-model="modal_checked")
                  .kenga-modal-body
                    .kenga-modal-window(:style="spModalWindowStyle")
                      label.kenga-modal-label(for='#')
                        svg(viewBox='0 0 16 16', width='16', height='16', aria-hidden='true')
                          polygon(
                            fill='#fff',
                            points='14.4,3.1 12.9,1.6 8,6.6 3.1,1.6 1.6,3.1 6.6,8 1.6,12.9 3.1,14.4 8,9.4 12.9,14.4 14.4,12.9 9.4,8'
                          )
                      .kenga-modal-inner
                        .countdown_wrap(v-if="countdown", :style="{ backgroundColor: countdown_bg_color}")
                          .countdown_txt(:style="{ color: countdown_font_color}")
                            | {{prefix_countdown_text}}
                            template(v-if="countdown_type == 'specific_date' && daysleft!=0")
                              em {{daysleft}}
                              |日
                            em {{hoursleft}}
                            |時間
                            em {{minutesleft}}
                            |分
                            em {{secondsleft}}
                            |秒
                        .kenga-modal-content
                          img(:src="spImageSrc", :style="iframe_mode ? 'width:100%;height:auto;display:block;' : ''", :key="'sp-' + spImageSrc", v-if="spImageSrc")
                          .texts(v-if="!iframe_mode && title", :class="{no_action: !arrow_btn_flag}")
                            .title
                              a(href='#', target='_blank') {{title}}
                            .action
                              a(href='#', target='_blank')
                                img(src="/img/rectan_action_btn.png")
                          .texts(v-else-if="!iframe_mode && arrow_btn_flag")
                            .title
                              p {{""}}
                            .action
                              a(href='#', target='_blank')
                                img(src="/img/rectan_action_btn.png")
                      #kenga_footer(v-if="show_credit")
                        a(href='https://sitelead.net', target='_blank') Powered By SiteLead
              .preview-empty.preview-empty--in-phone(v-else)
                | スマートフォン用画像が登録されていません
            .buttons
              span.on-off
              span.sleep
              span.up
              span.down
            .bottom-bar
            .iphone-bottom
              span
</template>

<script>
import { required, url } from 'vuelidate/lib/validators';
import Vue from 'vue';
import {
  mapPcProgressToPreviewHeight,
  mapPcSettingPercentToPreviewWidth,
  mapPcSettingPxToPreviewWidth,
  mapSpColumnWidthToScale,
  resolvePcSizeProgress,
  PC_SETTING_PX_MIN,
  PC_PREVIEW_SCREEN_WIDTH_RATIO,
  PC_PREVIEW_SCREEN_HEIGHT_RATIO,
  SP_PREVIEW_DESIGN_HEIGHT,
  SP_PREVIEW_DESIGN_WIDTH,
} from '../utils/preview_size';

const PC_PREVIEW_REFERENCE_VIEWPORT = 1_800;
const PC_PREVIEW_FOOTER_HEIGHT_RATIO = 0.045;
const SP_PREVIEW_TOP_PADDING = 8;
const SP_PREVIEW_BOTTOM_PADDING = 8;
const SP_PREVIEW_WRAP_MARGIN_TOP = 0;

export default {
  props: {
    show_credit: {type: Boolean, default: true},
    show_play_btn: {type: Boolean, default: true},
    auto_play: {type: Boolean, default: false},
    demo_play: {type: Boolean, default: false},
  },
  data(){
    return {
      modal_checked: false,
      modal_playing: false,
      interval_obj: null,
      daysleft: "",
      hoursleft: "",
      minutesleft: "",
      secondsleft: "",
      milliSecondsleft: "",
      demo_play_interval: "",
      spScale: 0.7,
      spResizeObserver: null,
      pcScreenWidth: 0,
      pcScreenHeight: 0,
    }
  },
  methods: {
    updatePreviewLayout() {
      this.updatePcScreenMetrics();
      this.$nextTick(() => {
        this.updateSpScale();
      });
    },
    updateSpScale() {
      const wrap = this.$refs.spFitWrap;
      if (!wrap) {
        return;
      }
      const availableWidth = Math.max(wrap.clientWidth - 8, 0);
      if (!availableWidth) {
        return;
      }

      // 幅だけに合わせる。高さで潰して枠下に潜らせない
      this.spScale = mapSpColumnWidthToScale(availableWidth);
    },
    updatePcScreenMetrics() {
      const screen = this.$refs.pcPreviewScreen;
      if (screen && screen.clientWidth && screen.clientHeight) {
        this.pcScreenWidth = screen.clientWidth;
        this.pcScreenHeight = screen.clientHeight;
        return;
      }

      const imac = this.$refs.pcImacBg;
      if (!imac || !imac.clientWidth || !imac.clientHeight) {
        return;
      }
      this.pcScreenWidth = Math.round(imac.clientWidth * PC_PREVIEW_SCREEN_WIDTH_RATIO);
      this.pcScreenHeight = Math.round(imac.clientHeight * PC_PREVIEW_SCREEN_HEIGHT_RATIO);
    },
    scalePcPreviewSize(pixelSize) {
      const screenWidth = this.pcScreenWidth || 360;
      return Math.round(pixelSize * screenWidth / PC_PREVIEW_REFERENCE_VIEWPORT);
    },
    resolvePcPreviewWidth(maxWidth, isPercent) {
      const screenWidth = this.pcScreenWidth || 360;
      if (isPercent) {
        return mapPcSettingPercentToPreviewWidth(parseFloat(maxWidth) / 100, screenWidth);
      }
      const pixelWidth = typeof maxWidth === 'number' ? maxWidth : parseInt(maxWidth, 10);
      return mapPcSettingPxToPreviewWidth(pixelWidth || PC_SETTING_PX_MIN, screenWidth);
    },
    pcPreviewMaxImageHeight(maxWidth, isPercent) {
      const screenHeight = this.pcScreenHeight || 200;
      const previewWidth = this.resolvePcPreviewWidth(maxWidth, isPercent);
      const closeHeight = Math.max(8, Math.round(previewWidth * 0.04));
      const footerHeight = this.show_credit
        ? Math.max(10, Math.round(previewWidth * PC_PREVIEW_FOOTER_HEIGHT_RATIO))
        : 0;
      let reserved = closeHeight + footerHeight + 12;

      if (this.countdown) {
        reserved += this.scalePcPreviewSize(40);
      }
      if (this.title || this.arrow_btn_flag) {
        reserved += this.scalePcPreviewSize(32);
      }

      const progress = resolvePcSizeProgress(maxWidth, isPercent);
      return Math.max(
        64,
        mapPcProgressToPreviewHeight(progress, screenHeight, reserved)
      );
    },
    pcModalBaseStyle(maxWidth, isPercent) {
      const previewWidth = this.resolvePcPreviewWidth(maxWidth, isPercent);
      const maxImageHeight = this.pcPreviewMaxImageHeight(maxWidth, isPercent);
      const closeHeight = Math.max(8, Math.round(previewWidth * 0.04));
      const footerHeight = this.show_credit
        ? Math.max(10, Math.round(previewWidth * PC_PREVIEW_FOOTER_HEIGHT_RATIO))
        : 0;

      return {
        '--pc-preview-window-width': previewWidth + 'px',
        '--pc-preview-close-height': closeHeight + 'px',
        '--pc-preview-footer-height': footerHeight + 'px',
        '--pc-preview-max-img-height': maxImageHeight + 'px',
        maxHeight: '100%',
        boxSizing: 'border-box',
        padding: '0',
      };
    },
    toggleModalPlay(){
      this.modal_playing = !this.modal_playing
    },
    toggleModalChecked(){
      this.modal_checked = !this.modal_checked
    },
    playModal(){
      this.modal_checked = true
      setTimeout(()=>{this.modal_checked = false}, 100)
    },
    autoChangeAnimation(){
      var current = this.$store.state.creative.preview_list.pop_up_animation
      var next
      if(current == "fade_in"){
        next = "spin_in"
      } else if (current == "spin_in"){
        next = "bottom_to_top"
      } else if (current == "bottom_to_top"){
        next = "top_to_bottom"
      } else if (current == "top_to_bottom"){
        next = "left_to_right"
      } else if (current == "left_to_right"){
        next = "right_to_left"
      } else if (current == "right_to_left"){
        next = "fade_in"
      }
      this.$store.commit("creative/setPreviewListPopUpAnimation", next)
      if(this.$store.state.creative.preview_list.countdown_type == "day_end"){
        this.$store.commit("creative/setCountdownType", "time_limit")
      } else {
        this.$store.commit("creative/setCountdownType", "day_end")
      }
    },
    calculateCountdownTxt(){
      var now = new Date()
      var daysleft = 0
      var hoursleft = 0
      var minutesleft = 0
      var secondsleft = 0
      var milliSecondsleft = 0

      if(this.countdown_type == "day_end"){
        hoursleft = 23-now.getHours()
        minutesleft = 59-now.getMinutes()
        secondsleft = 59-now.getSeconds()
      } else if(this.countdown_type == "time_limit"){
        const time_diff_milli = this.countdown_unix_time_left - now.getTime()
        if(time_diff_milli <= 0){
          hoursleft = 0
          minutesleft = 0
          secondsleft = 0
          milliSecondsleft = 0
        } else {
          const time_diff_sec = time_diff_milli/1000
          hoursleft = parseInt(time_diff_sec/3600)
          minutesleft = parseInt((time_diff_sec - hoursleft*3600)/60)
          secondsleft = parseInt(time_diff_sec - hoursleft*3600 - minutesleft*60)
          milliSecondsleft = (parseInt((time_diff_milli - hoursleft*3600*1000 - minutesleft*60*1000 - secondsleft*1000)/10)).toString()
          if(milliSecondsleft.length == 1){
            milliSecondsleft = "0"+milliSecondsleft
          }
        }
      } else if(this.countdown_type == "specific_date"){
        const time_diff_milli = this.countdown_unix_time_left - now.getTime()
        if(time_diff_milli <= 0){
          hoursleft = 0
          minutesleft = 0
          secondsleft = 0
          milliSecondsleft = 0
        } else {
          const time_diff_sec = time_diff_milli/1000
          daysleft = parseInt(time_diff_sec/86400)
          hoursleft = parseInt((time_diff_sec - daysleft*86400)/3600)
          minutesleft = parseInt((time_diff_sec - daysleft*86400 - hoursleft*3600)/60)
          secondsleft = parseInt(time_diff_sec - daysleft*86400 - hoursleft*3600 - minutesleft*60)
          milliSecondsleft = (parseInt((time_diff_milli - daysleft*86400*1000 - hoursleft*3600*1000 - minutesleft*60*1000 - secondsleft*1000)/10)).toString()
          if(milliSecondsleft.length == 1){
            milliSecondsleft = "0"+milliSecondsleft
          }
        }
      }

      if(hoursleft<10 && hoursleft!=0) hoursleft = "0"+hoursleft
      if(minutesleft<10) minutesleft = "0"+minutesleft
      if(secondsleft<10) secondsleft = "0"+secondsleft

      this.daysleft = daysleft
      this.hoursleft = hoursleft
      this.minutesleft = minutesleft
      this.secondsleft = secondsleft
      this.milliSecondsleft = milliSecondsleft
    }
  },
  watch: {
    modal_playing: function (val) {
      if(val){
        this.modal_checked = true
        this.playModal()
        this.interval_obj = setInterval(function() {this.playModal()}.bind(this), 2000)
      } else {
        this.modal_checked = false
        clearInterval(this.interval_obj)
      }
    },
    '$store.state.creative.preview_list.pop_up_animation': function () {
      this.playModal()
    },
    show_sp: function (val) {
      if (val) {
        this.$nextTick(() => {
          this.updatePreviewLayout();
        });
      }
    },
    show_pc: function (val) {
      if (val) {
        this.$nextTick(() => {
          this.updatePcScreenMetrics();
        });
      }
    },
    hasPcPreviewContent: function (val) {
      if (val) {
        this.$nextTick(() => {
          this.updatePcScreenMetrics();
        });
      }
    },
  },
  computed: {
    spWrapStyle() {
      const scaledHeight = Math.ceil(SP_PREVIEW_DESIGN_HEIGHT * this.spScale);
      // 影が切れないよう下に少し余裕
      const shadowPad = 12;

      return {
        height: `${scaledHeight + SP_PREVIEW_TOP_PADDING + SP_PREVIEW_BOTTOM_PADDING + shadowPad}px`,
        paddingTop: `${SP_PREVIEW_TOP_PADDING}px`,
        paddingBottom: `${SP_PREVIEW_BOTTOM_PADDING}px`,
        marginTop: `${SP_PREVIEW_WRAP_MARGIN_TOP}px`,
        width: '100%',
        // 横は layout 幅のはみ出しを枠内に収める。縦は切らない
        overflowX: 'hidden',
        overflowY: 'visible',
        boxSizing: 'border-box',
      };
    },
    spScaleInnerStyle() {
      const scale = this.spScale;
      // transform 後も layout が 423x877 のまま残る分を打ち消す
      const widthInset = Math.round(SP_PREVIEW_DESIGN_WIDTH * (scale - 1) / 2);

      return {
        transform: `scale(${scale})`,
        transformOrigin: 'top center',
        width: `${SP_PREVIEW_DESIGN_WIDTH}px`,
        height: `${SP_PREVIEW_DESIGN_HEIGHT}px`,
        marginBottom: `${Math.round(SP_PREVIEW_DESIGN_HEIGHT * (scale - 1))}px`,
        marginLeft: `${widthInset}px`,
        marginRight: `${widthInset}px`,
      };
    },
    // バリデーション・互換用（プレースホルダ付き）
    image(){
      const img = this.$store.state.creative.preview_list.image;
      if(!img || img === ""){
        return "/images/600x500.png"
      }
      return img;
    },
    pc_image(){
      const img = this.$store.state.creative.preview_list.pc_image;
      if(!img || img === ""){
        return "/images/600x500.png"
      }
      return img;
    },
    title(){
      return this.$store.state.creative.preview_list.title
    },
    arrow_btn_flag(){
      return this.$store.state.creative.preview_list.arrow_btn_flag
    },
    is_fade_in(){
      return this.$store.state.creative.preview_list.pop_up_animation == "fade_in"
    },
    is_spin_in(){
      return this.$store.state.creative.preview_list.pop_up_animation == "spin_in"
    },
    is_bottom_to_top(){
      return this.$store.state.creative.preview_list.pop_up_animation == "bottom_to_top"
    },
    is_top_to_bottom(){
      return this.$store.state.creative.preview_list.pop_up_animation == "top_to_bottom"
    },
    is_left_to_right(){
      return this.$store.state.creative.preview_list.pop_up_animation == "left_to_right"
    },
    is_right_to_left(){
      return this.$store.state.creative.preview_list.pop_up_animation == "right_to_left"
    },
    countdown(){
      return this.$store.state.creative.preview_list.countdown
    },
    countdown_bg_color(){
      return this.$store.state.creative.preview_list.countdown_bg_color
    },
    countdown_font_color(){
      return this.$store.state.creative.preview_list.countdown_font_color
    },
    prefix_countdown_text(){
      return this.$store.state.creative.preview_list.prefix_countdown_text
    },
    countdown_type(){
      return this.$store.state.creative.preview_list.countdown_type
    },
    countdown_unix_time_left(){
      return this.$store.state.creative.countdown_unix_time_left
    },
    is_upload_image(){
      return this.$store.state.creative.preview_list.is_upload_image
    },
    is_upload_pc_image(){
      return this.$store.state.creative.preview_list.is_upload_pc_image
    },
    spModalWindowStyle() {
      // iPhone画面幅 375px × モーダル 90%
      const spWindowWidth = Math.round(375 * 0.9);
      return {
        padding: '0',
        boxSizing: 'border-box',
        width: '90%',
        maxWidth: '90%',
        maxHeight: '92%',
        '--sp-preview-window-width': spWindowWidth + 'px',
      };
    },
    pcModalWindowStyle() {
      const maxWidth = this.$store.state.creative.preview_list.max_width;
      const isPercent = typeof maxWidth === 'string' && maxWidth.includes('%');
      return this.pcModalBaseStyle(maxWidth, isPercent);
    },
    // 画面枠にはモーダル幅を載せない（CSSの絶対配置を壊すため）
    pcPreviewScreenStyle() {
      const maxWidth = this.$store.state.creative.preview_list.max_width;
      const isPercent = typeof maxWidth === 'string' && maxWidth.includes('%');
      const previewWidth = this.resolvePcPreviewWidth(maxWidth, isPercent);

      return {
        '--pc-preview-window-width': previewWidth + 'px',
        '--pc-preview-max-img-height': this.pcPreviewMaxImageHeight(maxWidth, isPercent) + 'px',
        '--pc-preview-close-height': Math.max(8, Math.round(previewWidth * 0.04)) + 'px',
        '--pc-preview-footer-height': this.show_credit
          ? Math.max(10, Math.round(previewWidth * PC_PREVIEW_FOOTER_HEIGHT_RATIO)) + 'px'
          : '0px',
      };
    },
    pcIframeWrapStyle() {
      const maxWidth = this.$store.state.creative.preview_list.max_width;
      const isPercent = typeof maxWidth === 'string' && maxWidth.includes('%');

      return {
        width: '100%',
        height: 'auto',
        aspectRatio: `${this.iframe_width_pc} / ${this.iframe_height_pc}`,
        maxWidth: '100%',
        maxHeight: this.pcPreviewMaxImageHeight(maxWidth, isPercent) + 'px',
        margin: '0 auto',
      };
    },
    pcSizeLabel() {
      const maxWidth = this.$store.state.creative.preview_list.max_width;
      if (maxWidth === undefined || maxWidth === null || maxWidth === '') {
        return '';
      }
      if (typeof maxWidth === 'string' && maxWidth.includes('%')) {
        return maxWidth;
      }
      return maxWidth + 'px';
    },
    // SP専用: 他デバイス画像へフォールバックしない
    rawSpUploadPath() {
      return this.$store.state.creative.preview_upload_image_path || '';
    },
    rawSpImage() {
      return this.$store.state.creative.preview_list.image || '';
    },
    // PC専用: 他デバイス画像へフォールバックしない
    rawPcUploadPath() {
      return this.$store.state.creative.preview_upload_pc_image_path || '';
    },
    rawPcImage() {
      return this.$store.state.creative.preview_list.pc_image || '';
    },
    spImageSrc() {
      if (this.iframe_mode) return "/img/iframe_preview_dummy_sp.png";
      if (!this.image_mode) return null;
      // SP専用パスのみ（PC画像へはフォールバックしない）
      if (this.is_upload_image == 1) {
        return this.rawSpUploadPath || this.rawSpImage || null;
      }
      if (this.is_upload_image == 0) {
        return this.rawSpImage || null;
      }
      return null;
    },
    pcImageSrc() {
      if (this.iframe_mode) return "/img/iframe_preview_dummy_pc.png";
      if (!this.image_mode) return null;
      // PC専用パスのみ（SP画像へはフォールバックしない）
      if (this.is_upload_pc_image == 1) {
        return this.rawPcUploadPath || this.rawPcImage || null;
      }
      if (this.is_upload_pc_image == 0) {
        return this.rawPcImage || null;
      }
      return null;
    },
    show_pc(){
      return this.$store.state.creative.preview_list.show_pc
    },
    show_sp(){
      return this.$store.state.creative.preview_list.show_sp
    },
    show_device(){
      return this.$store.state.creative.preview_list.show_device
    },
    iframe_mode() {
      return this.$store.state.creative.preview_list.media_type === "iframe" ||
        !!this.$store.state.creative.preview_list.iframe_embed_url;
    },
    iframe_embed_url() {
      return this.$store.state.creative.preview_list.iframe_embed_url;
    },
    image_mode() {
      return this.$store.state.creative.preview_list.media_type === "image"
        || !this.$store.state.creative.preview_list.media_type;
    },
    iframe_width_pc() {
      return this.$store.state.creative.preview_list.iframe_width_pc || 560;
    },
    iframe_height_pc() {
      return this.$store.state.creative.preview_list.iframe_height_pc || 400;
    },
    iframe_width_sp() {
      return this.$store.state.creative.preview_list.iframe_width_sp || 320;
    },
    iframe_height_sp() {
      return this.$store.state.creative.preview_list.iframe_height_sp || 480;
    },
    hasPcPreviewContent() {
      if (this.iframe_mode) {
        return !!this.iframe_embed_url;
      }
      return !!this.pcImageSrc;
    },
    hasSpPreviewContent() {
      if (this.iframe_mode) {
        return !!this.iframe_embed_url;
      }
      return !!this.spImageSrc;
    },
  },
  validations: {
    image: {
      required,
      url
    },
    pc_image: {
      required,
      url
    },
    title: {
      required
    },
    link: {
      required,
      url
    },
  },
  async mounted(){
    await Vue.nextTick()
    if(this.demo_play){
      setInterval(function() {this.autoChangeAnimation()}.bind(this), 3000)
    }
    this.calculateCountdownTxt()
    setInterval(function() {this.calculateCountdownTxt()}.bind(this), 10)
    this.updatePreviewLayout()
    if (typeof ResizeObserver !== "undefined") {
      const observeTarget = this.$el.closest('#previe_area') || this.$el
      this.spResizeObserver = new ResizeObserver(() => {
        this.updatePreviewLayout()
      })
      this.spResizeObserver.observe(observeTarget)
    } else {
      window.addEventListener("resize", this.updatePreviewLayout)
    }
  },
  beforeDestroy() {
    if (this.spResizeObserver) {
      this.spResizeObserver.disconnect()
      this.spResizeObserver = null
    } else {
      window.removeEventListener("resize", this.updatePreviewLayout)
    }
  },
}
</script>
<style lang="scss" scoped>
.btn .fa{
  margin-right: 5px;
}
.preview-stack {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  align-items: start;
}
.device-panel {
  border: 1px solid #dfe5ec;
  border-radius: 9px;
  padding: 10px;
  background: #f8fafc;
  overflow: visible;
}
.device-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 700;
}
.preview-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100px;
  padding: 16px;
  color: #6b7280;
  font-size: 12px;
  text-align: center;
  background: #eef1f5;
  border-radius: 6px;
  border: 1px dashed #c9d3df;
}
.preview-empty--in-phone,
.preview-empty--in-screen {
  position: absolute;
  inset: 0;
  min-height: 0;
  border-radius: 0;
  z-index: 2;
}
</style>
